import React from "react";
import { MdOutlineArrowLeft } from "react-icons/md";

const Staff = () => {
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Our Staff
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/">
                  <p className="text-blue-700 ">Back</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap -m-2">
            <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
              <div class="h-full flex items-center bg-gray-100  shadow-lg p-4 rounded-lg">
                <img
                  alt="team"
                  class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-lg mr-4"
                  src="\Images\staff\Sm_babu.png"
                />
                <div class="flex-grow">
                  <h2 class="text-gray-900 title-font font-medium">S.M Babu</h2>
                  <p class="text-gray-500">Founder, Head Cook</p>
                </div>
              </div>
            </div>
            <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
              <div class="h-full flex items-center bg-gray-100  shadow-lg p-4 rounded-lg">
                <img
                  alt="team"
                  class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-lg mr-4"
                  src="/Images\staff\Nagesh.png"
                />
                <div class="flex-grow">
                  <h2 class="text-gray-900 title-font font-medium">
                    Nagesh D{" "}
                  </h2>
                  <p class="text-gray-500">Head Cook</p>
                </div>
              </div>
            </div>
            <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
              <div class="h-full flex items-center bg-gray-100  shadow-lg p-4 rounded-lg">
                <img
                  alt="team"
                  class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-lg mr-4"
                  src="/Images\staff\Ramu.png"
                />
                <div class="flex-grow">
                  <h2 class="text-gray-900 title-font font-medium">Ramu</h2>
                  <p class="text-gray-500">Sweet expert</p>
                </div>
              </div>
            </div>
            <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
              <div class="h-full flex items-center bg-gray-100  shadow-lg p-4 rounded-lg">
                <img
                  alt="team"
                  class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-lg mr-4"
                  src="/Images\staff\Manjunath.png"
                />
                <div class="flex-grow">
                  <h2 class="text-gray-900 title-font font-medium">
                    Manjunath{" "}
                  </h2>
                  <p class="text-gray-500">cook asistent</p>
                </div>
              </div>
            </div>
            <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
              <div class="h-full flex items-center bg-gray-100  shadow-lg p-4 rounded-lg">
                <img
                  alt="team"
                  class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-lg mr-4"
                  src="/Images\staff\malli.png"
                />
                <div class="flex-grow">
                  <h2 class="text-gray-900 title-font font-medium">Malli</h2>
                  <p class="text-gray-500">Cook asistent</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </section>
    </>
  );
};

export default Staff;
